import ByodAdapter from './byod';

export default class MeasurementAdapter extends ByodAdapter {}
